import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
  cache: false,
};
export default {
  path: "/volunteer",
  name: "volunteer",
  redirect: {
    name: "volunteer",
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: "volunteerTeam",
      name: "volunteerTeam",
      meta: {
        title: "志愿服务组织/队伍管理",
      },
      component: () => import("@/pages/volunteer/volunteerTeam/index.vue"),
    },
    {
      path: "volunteerRegistration",
      name: "volunteerRegistration",
      meta: {
        title: "志愿者管理",
      },
      component: () =>
        import("@/pages/volunteer/volunteerRegistration/index.vue"),
    },
    {
      path: "volunteerActivity",
      name: "volunteerActivity",
      meta: {
        title: "志愿活动管理",
      },
      component: () => import("@/pages/volunteer/volunteerActivity/index.vue"),
    },
    {
      path: "volunteerActivityApplication",
      name: "volunteerActivityApplication",
      meta: {
        title: "志愿活动申请",
      },
      component: () =>
        import("@/pages/volunteer/volunteerActivityApplication/index.vue"),
    },
    {
      path: "volunteerActivityReview",
      name: "volunteerActivityReview",
      meta: {
        title: "志愿活动审核",
      },
      component: () =>
        import("@/pages/volunteer/volunteerActivityReview/index.vue"),
    },
    {
      path: "volunteerActivityNew",
      name: "volunteerActivityNew",
      meta: {
        title: "志愿活动",
      },
      component: () =>
        import("@/pages/volunteer/volunteerActivityNew/index.vue"),
    },
    {
      path: "volunteerTeamReview",
      name: "volunteerTeamReview",
      meta: {
        title: "志愿服务队伍审核",
      },
      component: () =>
        import("@/pages/volunteer/volunteerTeamReview/index.vue"),
    },
    {
      path: "RankingList",
      name: "RankingList",
      meta: {
        title: "志愿者排行榜",
      },
      component: () => import("@/pages/volunteer/RankingList/index.vue"),
    },
    {
      path: "demeanor",
      name: "demeanor",
      meta: {
        title: "志愿服务风采",
      },
      component: () => import("@/pages/volunteer/demeanor/index.vue"),
    },
    {
      path: "policy",
      name: "policy",
      meta: {
        title: "志愿服务礼遇政策",
      },
      component: () => import("@/pages/volunteer/policy/index.vue"),
    },
  ],
};
